/* eslint-disable */

import * as conditioner from 'conditioner-core/conditioner-core.min';
import headernav from './blocks/header-nav';
import Breakpoint from './modules/breakpoint';

const appjs = document.getElementById('appjs');
const ParamsData = {};
for (let key in appjs.dataset) {
    ParamsData[key] = appjs.dataset[key];
}

export { ParamsData };


headernav();

// print css
const link = document.createElement('link');
link.rel = 'stylesheet';
link.media = 'print';
link.href = `${ParamsData.wp_theme_url}/assets/print.css`;
document.head.appendChild(link);

// OneTrust Cookies Consent
ParamsData.oneTrust_id && import('./modules/onetrust').then(module => module.Onetrust());

// MarkerIo bugReports
ParamsData.bug_report_id && import('./modules/markerIo').then(module => module.bugReport());

// Conditioner
conditioner.addPlugin({
    // the plugin "monitor" hook
    // use in html : <div data-module="modules/component.js" data-context="@visible true"></div>
    monitor: {
        // the name of our monitor, not prefixed with "@"
        name: 'visible',

        // the monitor factory method, this will create our monitor
        create: (context, element) => ({
            // current match state
            matches: false,

            // called by conditioner to start listening for changes
            addListener(change) {
                new IntersectionObserver((entries) => {
                    // update the matches state
                    this.matches = entries.pop().isIntersecting === context;

                    // inform conditioner of the new state
                    change();
                }).observe(element);
            },
        }),
    },

    // converts module aliases to paths
    moduleSetName: (name) => `./${name}.js`,

    // get the module constructor
    moduleGetConstructor: (module) => module.default,

    // override the import (this makes webpack bundle all the dynamically included files as well)
    // https://webpack.js.org/api/module-methods/#import-
    // - set to "eager" to create a single chunk for all modules
    // - set to "lazy" to create a separate chunk for each module
    moduleImport: (name) => import(/* webpackMode: "lazy" */ `${name}`),
});

conditioner.hydrate(document.documentElement);



// 404 stop animated gif
const btn_pause_gif = document.querySelector(".btn-pause-gif");
if (btn_pause_gif) {
    const img_access = document.querySelector(".img-access");
    if (img_access) {
        const img_animated = document.querySelector(".img-animated");
        btn_pause_gif.onclick = () => {
            if (btn_pause_gif.classList.contains("active")) {
                img_access.classList.remove("show");
                img_animated.classList.remove("hide");
                btn_pause_gif.classList.remove("active")
            } else {
                img_access.classList.add("show");
                img_animated.classList.add("hide");
                btn_pause_gif.classList.add("active")
            }
        }
    }

}


// rgpd gestion cookies tc
document.querySelectorAll('a[href="#access"]').forEach(link => {
    link.onclick = (e) => {
        e.preventDefault();
        window.tC.privacyCenter.showPrivacyCenter();
    };
});


/**
 * Tracking
 * add data-trk to links in wysiwyg
 */
const links = document.querySelectorAll(".strate-text a");
function slugify(str) {
    return String(str)
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
        .trim() // trim leading or trailing whitespace
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
}
links.forEach(link => link.setAttribute("data-trk", `{"intext": {"name":"${slugify(link.innerText)}"}}`))


// tracking test json  

/* const trks = document.querySelectorAll("[data-trk]");
trks.forEach(trk => {

    trk.onclick = (e) => {
        e.preventDefault();
        console.log(JSON.parse(trk.dataset.trk));
    }
    trk.addEventListener('click', (e) => {
        e.preventDefault();
        console.log(JSON.parse(trk.dataset.trk));
    });
}) */






